// export default BlogLayout;
import React, { useState, useEffect } from "react";
import {
  Card,
  Image,
  Flex,
  Text,
  Badge,
  Title,
  Grid,
  Container,
  ActionIcon,
} from "@mantine/core";
import axios from "axios";
import { Link } from "react-router-dom";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons";

function BlogLayout() {
  const [posts, setPosts] = useState([]);

  const [page, setPage] = useState(1);
  const [nrofpages, setNumberofpage] = useState(1);

  // When the page number changes call the api for posts.
  useEffect(() => {
    let wp_API_Url = `http://localhost:10039`;
    axios
      .get(`${wp_API_Url}/wp-json/wp/v2/posts`, { params: { page: page } })
      .then((response) => {
        // Store the number of posible pages.
        setNumberofpage(response.headers["x-wp-totalpages"]);
        // Store the posts from the response.
        console.log(response);
        setPosts(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [page, setPosts]);

  // Event handler: Decrease page count no lower then 1.
  const handlePrevPage = () => setPage(page - 1 ? page - 1 : 1);
  // Event handler: Increase page count no higher then nrofpages.
  const handleNextPage = () => setPage(page < nrofpages ? page + 1 : nrofpages);

  return (
    <>
      <section className="blog-page">
        <Flex
          justify="center"
          align="center"
          direction="column"
          wrap="wrap-reverse"
          py={150}
        >
          <Title weight={800} mb="sm">
            Newsroom
          </Title>
          <Text>Latest updates and Hand-picked resources.</Text>
        </Flex>
        <br />
        <Container size="lg">
          {console.log("Posts", posts)}
          <Grid gutter={40}>
            {posts &&
              posts.map((post) => (
                <Grid.Col span={6} key={post.id}>
                  <Card shadow="md" p="xl" radius="lg">
                    <Card.Section>
                      <Image
                        src={post.featured_image_url}
                        height={250}
                        alt="Norway"
                      />
                    </Card.Section>
                    <div style={{ padding: "30px 0 14px" }}>
                      <Badge color="pink" variant="light">
                        Featured
                      </Badge>
                      <Link to={`/post/${post.id}`} className="post-title">
                        {post.title.rendered}
                      </Link>{" "}
                      <Text
                        size="sm"
                        color="dimmed"
                        dangerouslySetInnerHTML={{
                          __html: post.excerpt.rendered,
                        }}
                      />
                    </div>
                  </Card>
                </Grid.Col>
              ))}
          </Grid>
          <br />
          <br />
          <div className="pagination">
            <ActionIcon
              variant="outline"
              color={"violet"}
              onClick={handlePrevPage}
            >
              <IconArrowLeft size="1rem" />
            </ActionIcon>
            <div style={{ margin: "0 10px" }}>
              Page {page} of {nrofpages}
            </div>
            <ActionIcon
              variant="outline"
              color={"violet"}
              onClick={handleNextPage}
            >
              <IconArrowRight size="1rem" />
            </ActionIcon>
          </div>
          <br />
          <br />
        </Container>
      </section>
    </>
  );
}
export default BlogLayout;
